import React from "react";
import SideNavigation from "./components/side-navigation";

const AttributesLayout = (props) => {
    return (
        <div className="row">
            <div className="column -span2">
                <SideNavigation location={props.location} />
            </div>
            <div className="column -span10">{props.children}</div>
        </div>
    );
};

export default AttributesLayout;
